import * as React from 'react';
import SidebarContent from '../Content/SidebarContent';
import {Card} from "@mui/material";
import {useEffect, useState} from "react";

export default function SidebarComputer(props) {

    const [classNameSide, setClassNameSide] = useState('Md-Sidebar-Computer activated')

    useEffect(()=>{

        let className = 'Md-Sidebar-Computer '

        className += props.isOpen ? 'activated' : 'disactivated'
        setClassNameSide(className)
    }, [props.isOpen])




    return (
        <Card open={props.isOpen} className={classNameSide} style={{
            overflowY:'auto'
        }} elevation={7}>
            <SidebarContent

                isOpen={props.isOpen}
                setIsOpen={props.setIsOpen}
                isComputer={props.isComputer}
            >
            </SidebarContent>
        </Card>
    );
}